import Cookies from 'js-cookie';
import AuthApi from "./AuthApi";

const get = require("lodash.get");

const USUARIO_KEY = "usuario_movimentacoes_servidores";
const AUTH_PUBLIC_COOKIE = 'modelo_auth_public';
// Funcionalidades do SGU no formato "recurso#acao": "#index_show" libera a
// listagem e o detalhe; "#new_edit_destroy" libera criar, editar e excluir.
// O acesso às telas vem só delas; o recorte por unidade é feito pela API.
// Perfis de Alta Gestão do SGU: "alta_gestao" vê todas as unidades;
// "alta_gestao_sgi" e "alta_gestao_slat" veem apenas as unidades da sua área.
export const FUNCIONALIDADE_ALTA_GESTAO = 'alta_gestao';
export const FUNCIONALIDADES_ALTA_GESTAO_RESTRITA = {
    alta_gestao_sgi: 'SGI',
    alta_gestao_slat: 'SLAT',
};
//const AUTH_PUBLIC_COOKIE = 'auth_public';

class Auth {
    constructor() {
        this.authApi = new AuthApi();
    }

    async login(dados) {
        try {
            const resposta = await this.authApi.autenticar(dados);
            const usuario = resposta.usuario;
            // Funcionalidades do(s) perfil(is) não privilegiado(s) no SGU, usadas
            // se o usuário escolher o perfil 'usuario' no modal.
            usuario.funcionalidades_perfil_usuario = resposta.funcionalidades_perfil_usuario || [];
            // Funcionalidades dos perfis privilegiados (Admin TI / Alta Gestão),
            // usadas se o usuário escolher o perfil 'admin_ti'; null se a API
            // não enviar (versão anterior).
            usuario.funcionalidades_perfil_admin_ti = resposta.funcionalidades_perfil_admin_ti || null;
            localStorage.setItem(USUARIO_KEY, JSON.stringify(usuario));
            return {
                requerEscolha: !!resposta.requer_escolha_permissao,
                perfilAtual: resposta.perfil_atual || null,
            };
        } catch (err) {
            console.log(err);
            const mensagem = get(err, 'response.data.mensagem', 'Houve um erro ao fazer login. Por favor tente novamente')
            throw mensagem;
        }
    }

    aplicarPerfil(perfil) {
        const usuario = this.usuario;
        console.log('[Auth.aplicarPerfil] perfil escolhido:', perfil);
        console.log('[Auth.aplicarPerfil] funcionalidades ANTES:', usuario?.funcionalidades);

        if (!usuario) {
            console.warn('[Auth.aplicarPerfil] usuario não encontrado no localStorage');
            return;
        }

        // Os acessos vêm do SGU, que devolve a união de todos os perfis:
        // 'usuario' fica só com as funcionalidades do perfil Usuario e
        // 'admin_ti' só com as dos perfis privilegiados, sem herdar as do
        // perfil Usuario (ex.: home#index_show).
        if (perfil === 'usuario') {
            usuario.funcionalidades = usuario.funcionalidades_perfil_usuario || [];
        } else if (perfil === 'admin_ti' && Array.isArray(usuario.funcionalidades_perfil_admin_ti)) {
            usuario.funcionalidades = usuario.funcionalidades_perfil_admin_ti;
        }

        console.log('[Auth.aplicarPerfil] funcionalidades DEPOIS:', usuario.funcionalidades);
        localStorage.setItem(USUARIO_KEY, JSON.stringify(usuario));
        console.log('[Auth.aplicarPerfil] localStorage atualizado');
    }

    logout() {
        try {
            localStorage.removeItem(USUARIO_KEY);
            Cookies.remove(AUTH_PUBLIC_COOKIE)
            window.close();
        } catch (err) {
            console.log(err);
            const mensagem = get(err, 'response.data.mensagem', 'Houve um erro ao fazer logout. Por favor tente novamente')
            throw mensagem;
        }
    }

    loggedIn() {
        return !!this.usuario;
    }

    get usuario() {
        const usuarioString = localStorage.getItem(USUARIO_KEY);
        if (usuarioString) {
            return JSON.parse(usuarioString);
        }
        return null;
    }

    // Funcionalidades do SGU no perfil escolhido.
    get funcionalidades() {
        return this.usuario?.funcionalidades || [];
    }

    // Criar, editar e excluir no recurso (ex.: 'formularios'): exige a
    // funcionalidade "<recurso>#new_edit_destroy" no SGU.
    podeEscrever(recurso) {
        return this.funcionalidades.includes(`${recurso}#new_edit_destroy`);
    }
}

export default Auth;